export default {
  tiles: [
    {
      id: 1,
      employeeImageUrl1:
        'https://www.nerdwallet.com/cdn/company/images/testimonials/v2/desktop/testimonials-amrita-desktop.jpg',
      employeeImageUrlMobile1:
        'https://www.nerdwallet.com/cdn/company/images/testimonials/v2/mobile/testimonials-amrita-desktop.jpg',
      employeeName1: 'Amrita Jayakumar',
      employeeTitle1: 'Content Nerd',
      employeeDescription1:
        "Everyone can benefit from learning how to use money effectively to accomplish goals. We're changing the perception that knowing how to manage your money is only for the wealthy.",
      employeeImageUrl2:
        'https://www.nerdwallet.com/cdn/company/images/testimonials/v2/desktop/testimonials-andrew-desktop.jpg',
      employeeImageUrlMobile2:
        'https://www.nerdwallet.com/cdn/company/images/testimonials/v2/mobile/testimonials-andrew-mobile.jpg',
      employeeName2: 'Andrew Hollenbach',
      employeeTitle2: 'Engineering Nerd',
      employeeDescription2:
        'I love the constant feedback we receive from users about how we have positively impacted their lives.',
    },
    {
      id: 2,
      employeeImageUrl1:
        'https://www.nerdwallet.com/cdn/company/images/testimonials/v2/desktop/testimonials-gianna-desktop.jpg',
      employeeImageUrlMobile1:
        'https://www.nerdwallet.com/cdn/company/images/testimonials/v2/mobile/testimonials-gianna-mobile.jpg',
      employeeName1: 'Gianna Sen - Gupta',
      employeeTitle1: 'Product Nerd',
      employeeDescription1:
        "What motivates me most is feeling that my work has an impact, and that I can see how that impact directly shapes peoples' lives.",
      employeeImageUrl2:
        'https://www.nerdwallet.com/cdn/company/images/testimonials/v2/desktop/testimonials-andrea-desktop.jpg',
      employeeImageUrlMobile2:
        'https://www.nerdwallet.com/cdn/company/images/testimonials/v2/mobile/testimonials-andrea-mobile.jpg',
      employeeName2: 'Andrea Coombes',
      employeeTitle2: 'Content Nerd',
      employeeDescription2:
        "I'm always struck by how smart, driven and ethical my colleagues are. Our guiding star is, first and foremost, helping consumers make smart money decisions.",
    },
    {
      id: 3,
      employeeImageUrl1:
        'https://www.nerdwallet.com/cdn/company/images/testimonials/v2/desktop/testimonials-vivian-desktop.jpg',
      employeeImageUrlMobile1:
        'https://www.nerdwallet.com/cdn/company/images/testimonials/v2/mobile/testimonials-vivian-mobile.jpg',
      employeeName1: 'Vivian Chan',
      employeeTitle1: 'Engineering Nerd',
      employeeDescription1:
        'Working at NerdWallet helps me continuously grow both my technical skills and personal financial knowledge.',
      employeeImageUrl2:
        'https://www.nerdwallet.com/cdn/company/images/testimonials/v2/desktop/testimonials-mickey-desktop.jpg',
      employeeImageUrlMobile2:
        'https://www.nerdwallet.com/cdn/company/images/testimonials/v2/mobile/testimonials-mickey-mobile.jpg',
      employeeName2: 'Mickey Kay',
      employeeTitle2: 'Engineering Nerd',
      employeeDescription2:
        'I take pride knowing that our entire strategy is based on a core mission of service.',
    },
    {
      id: 4,
      employeeImageUrl1:
        'https://www.nerdwallet.com/cdn/company/images/testimonials/v2/desktop/testimonials-maria-desktop.jpg',
      employeeImageUrlMobile1:
        'https://www.nerdwallet.com/cdn/company/images/testimonials/v2/mobile/testimonials-maria-mobile.jpg',
      employeeName1: 'Maria Can',
      employeeTitle1: 'Engineering Nerd',
      employeeDescription1:
        'I enjoy coming to work and feeling challenged and pushed to grow in my career — while also bettering the lives of individuals.',
      employeeImageUrl2:
        'https://www.nerdwallet.com/cdn/company/images/testimonials/v2/desktop/testimonials-braxton-desktop.jpg',
      employeeImageUrlMobile2:
        'https://www.nerdwallet.com/cdn/company/images/testimonials/v2/mobile/testimonials-braxton-mobile.jpg',
      employeeName2: 'Braxton Gunter',
      employeeTitle2: 'Engineering Nerd',
      employeeDescription2:
        "In my time at NerdWallet, the word 'nerd' has come to be synonymous with 'passionate.' That passion manifests in the product, and also in the relationships formed here.",
    },
    {
      id: 5,
      employeeImageUrl1:
        'https://www.nerdwallet.com/cdn/company/images/testimonials/v2/desktop/testimonials-kristyn-desktop.jpg',
      employeeImageUrlMobile1:
        'https://www.nerdwallet.com/cdn/company/images/testimonials/v2/mobile/testimonials-kristyn-mobile.jpg',
      employeeName1: 'Kristyn Braden',
      employeeTitle1: 'Design Nerd',
      employeeDescription1:
        "At NerdWallet, you're not just a number. You have the opportunity to make a big impact and receive tons of support from your peers.",
      employeeImageUrl2:
        'https://www.nerdwallet.com/cdn/company/images/testimonials/v2/desktop/testimonials-nicole-desktop.jpg',
      employeeImageUrlMobile2:
        'https://www.nerdwallet.com/cdn/company/images/testimonials/v2/mobile/testimonials-nicole-mobile.jpg',
      employeeName2: 'Nicole Varvitsiotes',
      employeeTitle2: 'Design Nerd',
      employeeDescription2:
        'Our team is extremely thoughtful about the words we place on the page because, well, words matter. They’re there to clarify, encourage, debunk, and congratulate because everyone deserves to succeed at making the most of their money and their life.',
    },
  ],
};
